import { render, staticRenderFns } from "./main-navbar.vue?vue&type=template&id=f312a04c&scoped=true&"
import script from "./main-navbar.vue?vue&type=script&lang=js&"
export * from "./main-navbar.vue?vue&type=script&lang=js&"
import style0 from "./main-navbar.vue?vue&type=style&index=0&id=f312a04c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f312a04c",
  null
  
)

export default component.exports